// src/components/Sales/EditSaleModal.jsx
import React, { useState, useEffect } from 'react';

const EditSaleModal = ({ isOpen, onClose, onSave, sale, isSaving }) => {
  const [formData, setFormData] = useState({
    qty: '',
    unitPrice: '',
    totalPrice: ''
  });

  useEffect(() => {
    if (sale && isOpen) {
      setFormData({
        qty: sale.qty || '',
        unitPrice: sale.unitPrice || sale.pricePerUnit || '',
        totalPrice: sale.totalPrice || sale.grandTotal || ''
      });
    }
  }, [sale, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => {
      const updated = { ...prev, [name]: value };
      
      // Auto-calculate total
      if (name === 'qty' || name === 'unitPrice') {
        const qty = name === 'qty' ? parseFloat(value) : parseFloat(prev.qty);
        const price = name === 'unitPrice' ? parseFloat(value) : parseFloat(prev.unitPrice);
        updated.totalPrice = (qty * price) || '';
      }
      
      return updated;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.qty || !formData.unitPrice) {
      alert('Please fill all fields');
      return;
    }

    onSave({
      qty: parseInt(formData.qty),
      unitPrice: parseFloat(formData.unitPrice),
      totalPrice: parseFloat(formData.totalPrice)
    });
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <header className="modal-header">
          <h3>Edit Sale #{sale?.id}</h3>
          <button className="close-modal-btn" onClick={onClose} disabled={isSaving}>×</button>
        </header>

        <div className="modal-body">
          <form id="editSaleForm" onSubmit={handleSubmit}>
            <div className="form-grid-modal">
              <label>Quantity *</label>
              <input 
                name="qty"
                type="number"
                min="1"
                className="custom-input" 
                value={formData.qty} 
                onChange={handleChange} 
                required 
                disabled={isSaving}
              />

              <label>Unit Price *</label>
              <input 
                name="unitPrice"
                type="number"
                step="0.01"
                className="custom-input" 
                value={formData.unitPrice} 
                onChange={handleChange} 
                required 
                disabled={isSaving}
              />

              <label>Total Price</label>
              <input 
                name="totalPrice"
                type="number"
                step="0.01"
                className="custom-input" 
                value={formData.totalPrice} 
                onChange={handleChange} 
                disabled
                style={{ background: '#f3f4f6' }}
              />
            </div>
          </form>
        </div>

        <footer className="modal-footer">
          <button className="btn btn-cancel" onClick={onClose} disabled={isSaving}>Cancel</button>
          <button className="btn btn-save" type="submit" form="editSaleForm" disabled={isSaving}>
            {isSaving ? 'Updating...' : 'Update Sale'}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default EditSaleModal;
